export const Data = [
  {
    type: "zh",
    itemLi:[
      {
        span :"联系我们",
        aa:[
          {
            text1:"联系方式",
            hrf:"/contactUs",
          },
          // {
          //   text1:"留言反馈",
          //   hrf:"/news2",
          // }
        ]
      }
      // ,
      // {
      //   span :"招贤纳士",
      //   aa:[
      //     {
      //       text1:"职位招聘",
      //       hrf:"/news2",
      //     }
      //   ]
      // }
      // ,
      // {
      //   span :"学术中心",
      //   aa:[
      //     {
      //       text1:"激光科普",
      //       hrf:"/news2",
      //     }
      //   ]
      // }
      ,{
        span :"新闻中心",
        aa:[
          {
            text1:"公司新闻",
            hrf:"/news2",
          },
          // {
          //   text1:"行业资讯",
          //   hrf:"/news2",
          // }
        ]
      },
      {
        span :"产品中心",
        aa:[
          {
            text1:"口腔Er:YAG激光治疗仪",
            hrf:"/product",
          },
          {
            text1:"技术特点",
            hrf:"/product",
          },
          {
            text1:"临床应用",
            hrf:"/product",
          },
          {
            text1:"设备参数",
            hrf:"/product",
          }
        ]
      },
      {
        span :"关于微创",
        aa:[
          {
            text1:"公司简介",
            hrf:"/aboutUs?path=gsjj",
          },
          {
            text1:"发展历程",
            hrf:"/aboutUs?path=fzlc",
          },
          // {
          //   text1:"企业文化",
          //   hrf:"/aboutUs",
          // },
          // {
          //   text1:"客户口碑",
          //   hrf:"/aboutUs",
          // },
          {
            text1:"公司资质",
            hrf:"/aboutUs?path=hxys",
          }
        ]
      }





    ],
    icp:"京ICP备2024091723号-1  ",
    ga:" 京公网安备11011302007356号",
    name:"本网站版权归微创未来（北京）激光技术有限公司所有",
    rx:"全国统一热线"
  },
  {
    type: "en",
    itemLi:[
      {
        span :"Contact Us",
        aa:[
          {
            text1:"Contact Information",
            hrf:"/en/contactUs",
          },
          // {
          //   text1:"留言反馈",
          //   hrf:"/news2",
          // }
        ]
      }
      // ,
      // {
      //   span :"招贤纳士",
      //   aa:[
      //     {
      //       text1:"职位招聘",
      //       hrf:"/news2",
      //     }
      //   ]
      // }
      // ,
      // {
      //   span :"学术中心",
      //   aa:[
      //     {
      //       text1:"激光科普",
      //       hrf:"/news2",
      //     }
      //   ]
      // }
      ,{
        span :"News Center",
        aa:[
          {
            text1:"Company News",
            hrf:"/en/news2",
          },
          // {
          //   text1:"行业资讯",
          //   hrf:"/news2",
          // }
        ]
      },
      {
        span :"Product Center",
        aa:[
          {
            text1:"Er:YAG Dental Laser Treatment System",
            hrf:"/en/product",
          },
          {
            text1:"Technical Features",
            hrf:"/en/product",
          },
          {
            text1:"Clinical Applications",
            hrf:"/en/product",
          },
          {
            text1:"Equipment Parameters",
            hrf:"/en/product",
          }
        ]
      },
      {
        span :"About Us",
        aa:[
          {
            text1:"Company Profile",
            hrf:"/en/aboutUs?path=gsjj",
          },
          {
            text1:"Development History",
            hrf:"/en/aboutUs?path=fzlc",
          },
          // {
          //   text1:"企业文化",
          //   hrf:"/aboutUs",
          // },
          // {
          //   text1:"客户口碑",
          //   hrf:"/aboutUs",
          // },
          {
            text1:"Company Qualifications",
            hrf:"/en/aboutUs?path=hxys",
          }
        ]
      }





    ],
    icp:"Beijing ICP Filing No. 2024091723-1  ",
    ga:" Beijing Public Security Network Security Record No. 11011302007356",
    name:"The copyright of this website belongs to Victrum (Beijing) Laser Technology Co., Ltd. ",
    rx:"National Unified Hotline"
  }
]



// WEBPACK FOOTER //
// ./src/components/js/Footer.js